import { STEP_ITEM_HEIGHT } from "~/components/build/Show/routes/steps/list/-components/constants";
import { TreeNode } from "~/components/build/Show/routes/steps/list/-components/TreeNode";
import { JobLabel } from "~/components/build/Show/routes/steps/list/-components/TreeNode/JobLabel";
import { StepLink } from "~/components/build/Show/routes/steps/list/-components/TreeNode/StepLink";
import { isJobFailed } from "~/components/build/Show/lib/useFilterStore";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { CommandJob } from "~/components/build/Show/lib/types";
import { isJobIgnored } from "~/components/build/Show/lib/isJobIgnored";
import { resolveJobUrl } from "~/components/build/Show/lib/urlForView";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep } from "~/lib/pipeline";
import useQueryParams from "~/components/build/Show/lib/useQueryParams";
import { jobQueryOptions } from "~/components/build/Show/lib/queries/job";
import { usePrefetchHandlers } from "~/components/build/Show/lib/usePrefetchHandlers";

interface CommandJobProps {
  step: CommandStep;
  job: CommandJob;
  depth: number;
}

export function CommandJobItem({ step, job, depth }: CommandJobProps) {
  const { build } = useBuild();
  const params = useQueryParams();
  const { currentLatestJobUuid } = useCurrentJobOrStep();

  const { onMouseEnter, onMouseLeave } = usePrefetchHandlers({
    queries: [jobQueryOptions(build, job.id)],
  });

  return (
    <StepLink
      state={step.state}
      type={step.type}
      to={resolveJobUrl(job.id, { open: !isJobIgnored(job) })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      active={job.id === params.jid || (job.id === currentLatestJobUuid && Boolean(params.jid))}
      depth={depth}
      failed={isJobFailed(job, build)}
      className={isJobIgnored(job) ? "cursor-not-allowed opacity-60" : ""}
      disabled={isJobIgnored(job)}
      title={isJobIgnored(job) ? job.tooltip || "Skipped jobs cannot be viewed" : undefined}
    >
      <JobLabel job={job} step={step} depth={depth} />
    </StepLink>
  );
}

export const createCommandJobNode = (step: CommandStep, job: CommandJob): TreeNode => ({
  id: job.id,
  height: STEP_ITEM_HEIGHT,
  render: ({ depth }) => <CommandJobItem step={step} job={job} depth={depth} />,
});
